var _defs, _path, _polygon, _polygon2, _polygon3, _polygon4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinnerGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96.98 96.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#69797e;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Spinner_gray") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#69797e",
    d: "M-1360.8,428.12a48.49,48.49,0,0,0-48.49,48.49,48.49,48.49,0,0,0,48.49,48.49,48.49,48.49,0,0,0,48.49-48.49A48.49,48.49,0,0,0-1360.8,428.12Zm0,91.59a43.1,43.1,0,0,1-43.1-43.1,43.1,43.1,0,0,1,43.1-43.1,43.1,43.1,0,0,1,43.1,43.1A43.1,43.1,0,0,1-1360.8,519.71Z",
    transform: "translate(1409.29 -428.12)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#69797e",
    points: "61.24 36.42 61.24 45.05 51.49 49.45 51.49 54.46 61.24 50.06 61.24 60.87 65.75 58.8 65.75 34.35 61.24 36.42"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#69797e",
    points: "31.25 57.85 47.99 65.3 47.99 60.29 31.25 52.85 31.25 57.85"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#69797e",
    points: "31.25 48.4 47.99 55.99 47.99 50.98 31.25 43.39 31.25 48.4"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#69797e",
    points: "31.25 33.21 31.25 38.22 47.99 45.76 47.99 40.76 31.25 33.21"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerGray);
export default __webpack_public_path__ + "static/media/Spinner_gray.4ffa9a62.svg";
export { ForwardRef as ReactComponent };